import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfirmDialogComponent, IConfirmData } from '../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { IBankAccount } from '../../../../shared/model/bank-account.model';
import { ICompany } from '../../../../shared/model/company.model';
import { BankAccountService } from '../../../../shared/services/bank-account.service';
import { CompanyService } from '../../../../shared/services/company.service';
import { IconService } from '../../../../shared/services/icon.service';

@Component({
  selector: 'app-details',
  templateUrl: './details.page.html',
  styleUrls: ['./details.page.scss']
})
export class DetailsPage implements OnInit {

  public company$!: Observable<ICompany>;
  public bankAccounts$!: Observable<IBankAccount[]>;

  constructor(
    private companyService: CompanyService,
    private bankAccountService: BankAccountService,
    private route: ActivatedRoute,
    private iconService: IconService,
    private router: Router,
    private dialog: MatDialog,
  ) {
    this.iconService.loadIcons([
      'edit',
      'delete',
      'settings'
    ]);
  }

  public ngOnInit(): void {
    const companyId = this.route.snapshot.paramMap.get('companyId');
    if (companyId) {
      this.company$ = this.companyService.get(companyId);
      this.bankAccounts$ = this.bankAccountService.getByCompanyId(companyId);
    }
  }

  public showDeleteDialog(company: ICompany): void {
    const data: IConfirmData = {
      title: `Delete company "${company.name}"?`,
      message: 'This will delete the company and it\'s bank accounts and cannot be undone.'
    };
    const dialog = this.dialog.open(ConfirmDialogComponent, { data });
    dialog.afterClosed().subscribe((confirm) => {
      if (confirm) {
        this.delete(company);
      }
    });
  }

  public delete(company: ICompany): void {
    company.deleted = true;
    this.companyService.update(company).then(() => {
      this.router.navigate(['/companies']);
    });
  }

}
